import * as bookingActions from '../actions/Booking';

const initialState = {
  list: [],
  status: 200
};

const bookings = (state = initialState, action) => {
  switch (action.type) {
    case bookingActions.GET_BOOKING_SUCCESS:
      return Object.assign({}, state, { list: action.payload });
    case bookingActions.GET_BOOKING_FAILURE:
      return Object.assign({}, state, {
        status: action.payload,
        error: action.error
      });
    default:
      return state;
  }
};

export default bookings;
